import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Menu } from '@mantine/core';
import classes from './ContextMenuActionIcon.module.css';

type ContextMenuActionIconProps = {
  visible: boolean;
};

export const ContextMenuActionIcon: React.FC<ContextMenuActionIconProps> = ({
  visible,
}) => {
  return (
    <Menu.Target>
      <ActionIcon
        variant="subtle"
        className={visible ? '' : classes.hidden}
        onClick={(e) => e.stopPropagation()}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </ActionIcon>
    </Menu.Target>
  );
};
